export enum SupplierCode {
    ZUMIGO = 1,
}